import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild, ɵCompiler_compileModuleSync__POST_R3__ } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { debug } from 'console';
import { UserService } from 'src/app/core/services/v2/user.service';
import { CreditCardPaymentInformation } from 'src/app/physician/models/healthSystemPaymentInformation';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';
import { UtilsService } from '../../../../core/services/v2/utils.service';

@Component({
  selector: 'app-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.scss']
})
export class CreditCardComponent implements OnInit {

  errorMessage: string;
  cardLength: number = 16;
  cvvLength: number = 3;
  cardType: string = "Visa";
  cardNumber: string;
  cardYear: number;
  cardMonth: string;
  cardCode: string;
  firstName: string;
  lastName: string;
  city: string;
  state: string;
  zip: string;
  address: string;
  accepted: boolean = false;
  currentYear = new Date().getFullYear();
  action : string = "";

  years = Array(20)
    .fill(0)
    .map((x, i) => {
      return {
        label: i + this.currentYear,
        value: i + this.currentYear,
      };
    });
  months = [
    {
      value: "01", 
      label: "Jan",
    },
    {
      value: "02",
      label: "Feb",
    },
    {
      value: "03",
      label: "Mar",
    },
    {
      value: "04",
      label: "Apr",
    },
    {
      value: "05",
      label: "May",
    },
    {
      value: "06",
      label: "Jun",
    },
    {
      value: "07",
      label: "Jul",
    },
    {
      value: "08",
      label: "Aug",
    },
    {
      value: "09",
      label: "Sep",
    },
    {
      value: "10",
      label: "Oct",
    },
    {
      value: "11",
      label: "Nov",
    },
    {
      value: "12",
      label: "Dec",
    },
  ];

  totalcost: any;

  title: string = "Credit Card";
  
  AuthorizeNetUserID : string = "";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any, 
    private userService : UserService,
    private windowsLoader: WindowLoaderService,
    public dialogRef: MatDialogRef<CreditCardComponent>,
    private utils: UtilsService,
  ) {
    this.AuthorizeNetUserID = data;
  }

  ngOnInit() {}

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  updatePaymentInfo() {
    const info = <CreditCardPaymentInformation>{
      cardNumber: this.cardNumber,
      cardType: this.cardType,
      cardExpirationMMYY: `${this.cardYear}-${this.cardMonth}`,
      cardCode: this.cardCode,
      firstName: this.firstName,
      lastName: this.lastName,
      address: this.address,
      city: this.city,
      state: this.state,
      zip: this.zip,
      AuthorizeNetUserID : this.AuthorizeNetUserID
      // email
    };

    this.windowsLoader.show();

    this.userService.InsertPaymentInformation(info).subscribe(data => {
      if (data.resultStatus != undefined && data.resultStatus.isSuccess==false) {
        this.utils.showMessageSnackBar(data.resultStatus.message, true)
      }
      this.windowsLoader.hide();
      this.dialogRef.close({event : 'InsertCard', data : data});
    });
  
  }

  onCancel(): void {
    this.dialogRef.close({event:'Cancel',data:null});
  }
  cardTypeChange(event: any) {
    if (event.target.value == 'Amex') {
      this.cardLength = 15;
      this.cvvLength = 4;
    }
    else {
      this.cardLength = 16;
      this.cvvLength = 3;
    }
    this.resetForm();
  }
  resetForm() {
    this.errorMessage="";
    this.cardType = "Visa";
    this.cardNumber = "";
    this.cardYear=0;
    this.cardMonth = "";
    this.cardCode = "";
    this.firstName = "";
    this.lastName = "";
    this.city = "";
    this.state = "";
    this.zip = "";
    this.address = "";
    this.accepted = false;
    this.currentYear = new Date().getFullYear();
    this.action = "";
  }
}
